export default "__VITE_ASSET__CsLXSe5J__"